import { Component, OnInit } from '@angular/core';
import { KioskStateService } from '../../services/kiosk-state.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BreadcrumbsService } from '../../../general/services/breadcrumbs.service';

@Component({
  selector: 'app-kiosk-page',
  templateUrl: './kiosk-page.component.html',
  styleUrls: ['./kiosk-page.component.css']
})
export class KioskPageComponent implements OnInit {

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private kioskStateService: KioskStateService,
    private logger: LoggerService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) { }

  ngOnInit() {
    this.loadingSpinnerService.show();
    this.kioskStateService.reinitialize().subscribe(
      done => {
        this.loadingSpinnerService.hide();
        this.logger.info('KioskPageComponent: kioskStateService reinitialized.');
      },
      error => {
        this.loadingSpinnerService.hide();
        this.logger.error(`KioskPageComponent: kioskStateService reinitialized error: ${error.message}.`);
      }
    );
  }

  get hasActiveBreadcrumbs() {
    return this.breadcrumbsService.hasActiveBreadcrumbs;
  }
}
